function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#CRU_svg__clip0_1_35)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 29.748c8.288 0 15-6.444 15-14.4S23.288.948 15 .948c-8.287 0-15 6.444-15 14.4s6.713 14.4 15 14.4z",
  fill: "#4C4849"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.937 22.644c2.863 0 5.2-1.596 5.2-5.496V10.62l1.7-1.092H16.8l1.875 1.092v6.456c0 3.72-2.538 4.224-3.725 4.224-1.188 0-3.525-.516-3.525-4.224V10.68l1.7-1.152H7.2l1.725 1.152v4.74l-2.325.36v1.068l2.325-.36v.516l-2.325.36v1.068l2.337-.36c.125 3.588 3.188 4.572 6 4.572zm8.463-8.556V13.02l-2.2.336v-2.244l1.337-.828-.362-.372-1.5.948s-.038 1.764-.038 6.492-3.762 5.76-5.4 5.76c-.15 0-.312 0-.5.012-1.45.048-3.65.108-5.662-2.316 1.262 2.136 3.262 2.76 6.125 2.76 3 0 6-2.016 6-6.168v-1.38l2.2-.336v-1.068l-2.2.336v-.516l2.2-.348zm-8.125 6.504c-2.3 0-3.363-1.248-3.363-3.456 0-3.036.025-6.264.025-6.264l1.5-.948.363.372-1.338.828v6.012c.013 1.92.975 3.456 2.813 3.456z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "CRU_svg__clip0_1_35"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgCru(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "064d502ec35396517d99bc34cce74d6d.svg";
export { SvgCru as ReactComponent };